import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import HelpSidebar from "./HelpSidebar";
import Breadcrumbs from "./Breadcrumbs";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "calc(100vh - 64px)",
    overflow: "hidden",
    backgroundColor: theme.palette.background.default,
  },
  sidebar: {
    width: 320,
    flexShrink: 0,
    borderRight: `1px solid ${theme.palette.divider}`,
    overflowY: "auto",
    backgroundColor: theme.palette.background.paper,
    ...theme.scrollbarStyles,
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  breadcrumbsWrapper: {
    padding: theme.spacing(2, 4),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  mainContent: {
    flex: 1,
    overflowY: "auto",
    padding: theme.spacing(4),
    maxWidth: 1200,
    margin: "0 auto",
    width: "100%",
    ...theme.scrollbarStyles,
  },
}));

const HelpLayout = ({ children, breadcrumbs }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.sidebar}>
        <HelpSidebar />
      </Box>
      <Box className={classes.content}>
        {breadcrumbs && (
          <Box className={classes.breadcrumbsWrapper}>
            <Breadcrumbs items={breadcrumbs} />
          </Box>
        )}
        <Box className={classes.mainContent}>{children}</Box>
      </Box>
    </Box>
  );
};

export default HelpLayout;
